import { render, staticRenderFns } from "./CustomErrorPage.vue?vue&type=template&id=31f549a8"
import script from "./CustomErrorPage.vue?vue&type=script&lang=js"
export * from "./CustomErrorPage.vue?vue&type=script&lang=js"
import style0 from "./CustomErrorPage.vue?vue&type=style&index=0&id=31f549a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports